<template>
  <div class="captcha-container">
    <!-- 验证码图片展示 -->
    <div class="captcha-image" @click="refreshCaptcha" ref="captchaCanvas">
      <canvas ref="canvas" width="120" height="40"></canvas>
    </div>
    <!-- 用户输入框 -->
    <input 
      v-model="userInput" 
      class="wj_text" 
      placeholder="请输入验证码" 
      @keyup.enter="verifyCaptcha"
    />
    <!-- 验证结果提示 -->
    <p v-if="message" :class="{ 'error': !isValid, 'success': isValid }">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Captcha',
  data() {
    return {
      captchaText: '', // 生成的验证码文本
      userInput: '',   // 用户输入的验证码
      isValid: null,   // 验证结果
      message: ''      // 提示信息
    };
  },
  mounted() {
    this.refreshCaptcha(); // 初始化生成验证码
  },
  methods: {
    // 生成随机验证码（4位字母数字）
    generateCaptcha() {
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // 移除容易混淆的小写字母
      let result = '';
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      this.captchaText = result;
      this.drawCaptcha();
    },
    
    // 绘制验证码到canvas
    drawCaptcha() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');
      
      // 清空画布
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // 设置浅色背景
      ctx.fillStyle = '#f8f8f8';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      
      // 绘制轻微干扰线（数量减少，颜色更浅）
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.getRandomColor(180, 220); // 更浅的颜色
        ctx.lineWidth = 0.5;
        ctx.beginPath();
        ctx.moveTo(
          Math.random() * canvas.width,
          Math.random() * canvas.height
        );
        ctx.lineTo(
          Math.random() * canvas.width,
          Math.random() * canvas.height
        );
        ctx.stroke();
      }
      
      // 绘制少量干扰点
      for (let i = 0; i < 100; i++) {
        ctx.fillStyle = this.getRandomColor(150, 200); // 浅色干扰点
        ctx.beginPath();
        ctx.arc(
          Math.random() * canvas.width,
          Math.random() * canvas.height,
          Math.random(), // 更小的点
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
      
      // 绘制验证码文本（加粗、更清晰）
      ctx.font = '22px Arial'; // 使用更清晰的字体和加粗
      
      // 为每个字符添加效果
      for (let i = 0; i < this.captchaText.length; i++) {
        ctx.save();
        
        // 轻微旋转角度 (-5° 到 5°)
        const angle = (Math.random() - 0.5) * 10 * Math.PI / 180;
        ctx.translate(20 + i * 25, 28); // 更好的位置
        ctx.rotate(angle);
        
        // 使用深色但保持可读性
        ctx.fillStyle = this.getRandomDarkColor();
        
        ctx.fillText(this.captchaText[i], 0, 0);
        ctx.restore();
      }
    },
    
    // 生成随机浅色（用于背景和干扰元素）
    getRandomColor(min, max) {
      const r = min + Math.floor(Math.random() * (max - min));
      const g = min + Math.floor(Math.random() * (max - min));
      const b = min + Math.floor(Math.random() * (max - min));
      return `rgb(${r}, ${g}, ${b})`;
    },
    
    // 生成随机深色（用于文本）
    getRandomDarkColor() {
      const colors = [
        '#333333', '#444444', '#555555',
        '#0066cc', '#009966', '#990066',
        '#3366cc', '#663399', '#993366'
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    },
    
    // 点击刷新验证码
    refreshCaptcha() {
      this.generateCaptcha();
      this.userInput = '';
      this.isValid = null;
      this.message = '';
    },
    
    // 验证用户输入
    verifyCaptcha() {
      this.isValid = this.userInput.toUpperCase() === this.captchaText; // 转为大写比较
      this.message = '';
      this.$emit('verified', this.isValid);
      return this.isValid;
    }
  }
};
</script>

<style scoped>
.captcha-container {
  margin: 10px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}
.captcha-image {
  display: inline-block;
  width: 120px;
  height: 40px;
  cursor: pointer;
  user-select: none;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f8f8f8;
}
.wj_text {
  width: 150px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #ddd;
  padding: 0 10px;
  outline: none;
}
.wj_text:focus {
  border-color: #409eff;
}
.error {
  color: #f56c6c;
  margin: 5px 0 0;
  font-size: 12px;
}
.success {
  color: #67c23a;
  margin: 5px 0 0;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/Captcha.vue